export default __webpack_public_path__ + "img/356102a3819f07186141c27d081d595d.png";